import '@angular/compiler';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageIpItemComponent } from './page.ip.item/page.ip.item.component';
import { LayoutMarketComponent } from './layout.market/layout.market.component';
import { PageMarketComponent } from './page.market/page.market.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageSellComponent } from './page.sell/page.sell.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageMarketInfoComponent } from './page.market.info/page.market.info.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageSearchAiComponent } from './page.search.ai/page.search.ai.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageConsultItemComponent } from './page.consult.item/page.consult.item.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageMarketCasesComponent } from './page.market.cases/page.market.cases.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageQnaComponent } from './page.qna/page.qna.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageValuationComponent } from './page.valuation/page.valuation.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageConsultationsComponent } from './page.consultations/page.consultations.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';

const INDEX_PAGE = "market";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            }
        ]
    },
    {
        component: LayoutMarketComponent,
        "children": [
            {
                "path": "ip/:id",
                component: PageIpItemComponent,
                "app_id": "page.ip.item"
            },
            {
                "path": "market",
                component: PageMarketComponent,
                "app_id": "page.market"
            },
            {
                "path": "sell",
                component: PageSellComponent,
                "app_id": "page.sell"
            },
            {
                "path": "market/info/:section",
                component: PageMarketInfoComponent,
                "app_id": "page.market.info"
            },
            {
                "path": "search/ai",
                component: PageSearchAiComponent,
                "app_id": "page.search.ai"
            },
            {
                "path": "consult/:id?",
                component: PageConsultItemComponent,
                "app_id": "page.consult.item"
            },
            {
                "path": "market/cases",
                component: PageMarketCasesComponent,
                "app_id": "page.market.cases"
            },
            {
                "path": "qna",
                component: PageQnaComponent,
                "app_id": "page.qna"
            },
            {
                "path": "valuation",
                component: PageValuationComponent,
                "app_id": "page.valuation"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "my-consultations",
                component: PageConsultationsComponent,
                "app_id": "page.consultations"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
